import {useEffect, useState, useRef} from "react";
import {MenuItem, TextField, Button, FormGroup, FormControlLabel, Checkbox, FormControl, FormLabel, FormHelperText } from "@mui/material";
import {templateThreeFieldError, templateThreeFieldErrors} from "../../data/templateThree";
import { FormContainerStyled, GeneralButtonStyled, AddOnContainerStyled, InputContainerWrapperStyled, InputContainerStyled, FileInputStyled, FileInputImageContainerStyled, tailSpinLoaderConfig } from "../generalStyles";
import { handleChange, handleAddOn, handleAddOnChange, handleRemoveAddOn, handleImageChange, handleImageInputButton, handleCheckBox, handleIsTriggered} from "../../functions/formFunctions";
import {handleSubmit} from "../../functions/generalFunctions";
import {ThemeProvider} from "@mui/material/styles";
import { TailSpin } from "react-loader-spinner";
import DisplayMsg from "../../DisplayMsg";
import { useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components";

function TemplateThreeForm({formData, setFormData, categoryList, restaurantName, activeDashboard }) {

    const [fieldsErrors, setFieldsErrors] = useState({});
    const [triggerFieldError, setTriggerFieldError] = useState({});
    const [tempImage, setTempImage] = useState("");
    const [loadAnimation, setLoadAnimation] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const fileInputRef = useRef(null);
    const [popUpMsg, setPopUpMsg] = useState({
        triggerMsg: false,
        msgToDisplay: "",
    })
    
    useEffect(() => {
        console.log("the current active dash board is: ", activeDashboard);
      
        setFieldsErrors(templateThreeFieldError)
        setTriggerFieldError(templateThreeFieldErrors)
    }, [])



    return (
        <FormContainerStyled style = {{width: "100%"}} onSubmit = {(e) => handleSubmit(e, setFieldsErrors, setTriggerFieldError, formData, activeDashboard, restaurantName, setPopUpMsg, navigate, location)}>
            <DisplayMsg popUpMsg={popUpMsg} setPopUpMsg={setPopUpMsg} />
            <TextField
                id = "standard-basic"
                label = "Name"
                name = "name_en"
                value = {formData.name_en}
                onChange = {(e) => handleChange(e, setFormData, setTriggerFieldError, setFieldsErrors, triggerFieldError)}
                helperText = {fieldsErrors.name_err}
                error = {triggerFieldError.name_err_bool}
            />
  
           <TextField
              
                id = "standard-basic"
                label = "Category"
                name = "category"
                select
                value = {formData.category}
                onChange = {(e) => handleChange(e, setFormData, setTriggerFieldError, setFieldsErrors, triggerFieldError)}
                helperText = {fieldsErrors.category_err}
                error = {triggerFieldError.category_err_bool}
            >
                <MenuItem value = "" disabled>
                    Select a category
                </MenuItem>
                {categoryList.map((option) => (
                    <MenuItem key = {option.value} value = {option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </TextField>
            <InputContainerWrapperStyled>
                <InputContainerStyled>
                    <FileInputStyled
                        type="file"
                        accept="image/*"
                        ref = {fileInputRef}
                        onChange={(e) => handleImageChange(e, setFormData, setLoadAnimation, setTempImage, setTriggerFieldError)}
                   />
                   <ThemeProvider theme = {GeneralButtonStyled}>
                    <Button
                        variant = "contained"
                        onClick = {() => handleImageInputButton(fileInputRef)}
                    >
                        edit image
                    </Button>
                   </ThemeProvider>
                </InputContainerStyled>
               
            </InputContainerWrapperStyled>
            <ImageTestStyled>
                   {
                    !loadAnimation ? (
                        <>
                            {triggerFieldError.image_err_bool && (
                                <div style = {{color: "#d32f2f", fontFamily: `"Roboto","Helvetica","Arial",sans-serif`, whiteSpace: "nowrap"}}>{fieldsErrors.image_err}</div>
                            )}
                            {tempImage ? <img src = {tempImage} style = {{width: "100%"}} /> :
                             <img src = {formData.image} style = {{width: "100%"}} />}
                        </>
                    ) : (
                        <TailSpin {...tailSpinLoaderConfig}/>
                    )
                   }
                </ImageTestStyled>
            <ThemeProvider theme = {GeneralButtonStyled}>
                <Button
                    type = "submit"
                    variant = "contained"
                    color = "primary"
                >
                    submit
                </Button>
            </ThemeProvider>
        </FormContainerStyled>
    )
}

const ImageTestStyled = styled.div`
    position: relative;
    width: 800px;
`

export default TemplateThreeForm;